import React, { PureComponent } from 'react';
import { Portal } from 'react-portal';
import EmailLookup from '../EmailLookup/EmailLookup';

import './TeaserBanner.scss';

export default class TeaserBanner extends PureComponent {
  render() {
    return (
      <Portal>
        <div className="TeaserBanner">
          <div className="TeaserInner">
            The data you are viewing breaks down TrustKit analysis for a sample
            app. <br />
            <EmailLookup />
          </div>
        </div>
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TeaserBanner/TeaserBanner.jsx